const ORDER = {
  ASCENDING: 'asc',
  DESCENDING: 'desc'
};

const MODE = {
  PERFORMANCE: 'performance',
  UNLIMITED: 'unlimited'
};

export { MODE, ORDER };
